<template>
  <div>
    <div class="banner innerpageBanner"><div class="container">
      <div class="caption"><div><h1>品鉴报告介绍</h1></div></div></div>
      <img src="https://image.insideburgundy.cn/insideburgundy/20190523/1efbe93b268849deb2c51236bd52c86c.png" class="cover-image">
    </div>

    <div class="container">
      <searchBox/>
      <div class="breadcrumbWrap">
        <div class="breadcrumb" style="padding-top:20px">
          <span property="itemListElement" typeof="ListItem">
            <a
              property="item"
              typeof="WebPage"
              title="Go to Jasper Morris Inside Burgundy."
              href="#/"
              class="home"
            >
              <span property="name">首页</span>
            </a>
            <meta property="position" content="1">
          </span> /
          <span property="itemListElement" typeof="ListItem">
            <span property="name">品鉴报告介绍</span>
            <meta property="position" content="2">
          </span>
        </div>
      </div>
    </div>
    <section class="innerPage">
      <!-- Search -->

      <!-- end-->

      <div class="container">

        <rightMenu title="分类"   :menudata='rightListdata' @OnClick='rightClick'/>

        <div class="leftCol tastingIntro">
          <p>&nbsp;</p>
          <p><h4>桶边品鉴</h4></p>
          <p>桶边品鉴通常在葡萄采收年份之后第二年的九至十二月进行。比如2017年份的酒，桶边品鉴的时间会在2018年9月至12月。很多时候这些酒仍然还在橡木桶或不锈钢罐中，有的可能刚刚装瓶。如果酒还没有完成最终的混酿，我们会给出一个分数的区间。如果酒已经被装瓶则会得到一个具体的分数。一份包含葡萄生长季节气候状况的年份品鉴报告会在每年末或次年初推出，这份报告可能会在接下来的几个月不断被补充完善。</p>
          <p>&nbsp;</p>
          <p><h4>Burgfest品鉴</h4></p>
          <p>
            Burgfest品鉴是指专门针对某一年份已经在市面流通的一级园和特级园展开的综合品鉴，年份间隔为三年，品鉴白葡萄酒的时间是五月，红葡萄酒是九月。比如2019年5月品鉴2016年份所有一级园和特级园的白葡萄酒，2019年9月品鉴2016年所有一级园和特级园的红葡萄酒。所有的酒样全部来自酒庄，品鉴按照AOC产区进行。葡萄酒首先会被按照地块进行划分，随后被倒进中性的玻璃容器中，再进行盲品。
          </p>
         <p>&nbsp;</p>
          <p><h4>1020品鉴</h4></p>
          <p>
            1020品鉴在每年6月进行。如其名称所示，10指采收年份距今10年的葡萄酒，20指采收年份距今20年的葡萄酒。如2019年我们会对2009年和1999年份的葡萄酒进行品鉴。这些酒全部由酒庄提供，和市场上已经在流通的酒相比来源略有不同。1020的品鉴不以盲品的形式进行。
          </p>
          <p>&nbsp;</p>
          <p><h4>酒庄垂直品鉴</h4></p>
          <p>
            酒庄垂直可能由酒庄或者值得信赖的葡萄酒收藏家组织，或源自我们自发的组织。我们会在品鉴报告中向读者说明葡萄酒的品鉴场景。这些品鉴通常不采用盲品的形式。
          </p>
          <p>&nbsp;</p>
          <p><h4>风土品鉴</h4></p>
          <p>
            风土品鉴指对特定风土、不同酒庄的品鉴，可以是垂直或平行的形式。品鉴的目的是确定某一风土的特征，并找出这片风土上最优秀的酒庄。
          </p>
          <div class="gridBoxes two small">
            <ul>
              <li>
                <div class="content">
                  <div class="img">
                    <img
                      src="https://image.insideburgundy.cn/insideburgundy/20190523/9da9b29c4609476db91febe13b41e306.png"
                      alt="An Introduction to Tasting Notes"
                      class="cover-image"
                    >
                  </div>
                  <div class="discription">
                    <h6>评分制度介绍</h6>
                    <p>我们如何定义一款出色的勃艮第酒？点击这里了解更多</p>
                  </div>
                  <a href="#/Introductionpage" target class="readmore">阅读更多</a>
                </div>
              </li>

              <li>
                <div class="content">
                  <div class="img">
                    <img
                      src="https://image.insideburgundy.cn/insideburgundy/20190529/a3162b257cee4c88ad88de62440ac29c.png"
                      alt="Tasting Reports"
                      class="cover-image"
                    >
                  </div>
                  <div class="discription">
                    <h6>品鉴报告</h6>
                    <p>很多酒评来自我们的年份报告、葡萄园及酒庄主题品鉴。您可以在下方各版块中进行查看。</p>
                  </div>
                  <a
                    href="#/Appraisal"
                    target
                    class="readmore"
                  >阅读更多</a>
                </div>
              </li>
            </ul>
            <!-- Top 3 blocks -->
          </div>

          <div class="recent_posts_grid">
            <div id="ajax_frame">
              <div id="ajax_content">
                <div class="gridBoxes three small">
                  <h2>最新报告</h2>

                  <reports    @totalInit='totalChange' :pageNo="pageNo"/>
                </div>

                <pagination  :pageNo='pageNo' :total='total' @pageChange="pageChange"/>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import searchBox from "../template/search";
import ajax from "../ajax";
import reports from '../template/reports'
import pagination from '../template/pagiation';
import rightMenu from '../template/rightMenu'
export default {
  data() {
    return {
      latestList: [],
      total:0,
      pageNo:0,
      rightListdata:{}
    };
  },
  components: {
    searchBox,
    pagination,
    rightMenu,
    reports
  },
  created() {
    this.getlatestList();
    this.getRightdata()
  },
  methods: {
    getRightdata(){
      ajax.getReportCategories().then(res=>{
        this.rightListdata = res.data
      })
    },
    rightClick(data){
      if(!data.child&&data.id)
        this.$router.push({path:'/Qualification',query:{id:data.id}})
    },
     pageChange(n){
      this.pageNo = n
    },
    totalChange(n){
      this.total = n
    },
    getlatestList() {
      ajax.getlatestList().then(res => {
        this.latestList = res.data;
      });
    },
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/Appraisalreport.vue